module.exports = __webpack_public_path__ + "media/pricing/Daily_Employee_Screening-a4a19b12.pdf";